module.exports = __webpack_public_path__ + "img/Into1.58066d67.png";